import React from 'react';
import Button from 'wonderbly-components/lib/Button';
import PropTypes from 'prop-types';

const CallToAction = props => (
  <Button
    href={props.href}
    colour={props.color}
    className="hero-iv-button"
    outlined={props.outlined}
    raised={props.raised}>
    {props.cta}
  </Button>
);

CallToAction.propTypes = {
  cta: PropTypes.string,
  color: PropTypes.string,
  outlined: PropTypes.bool,
  raised: PropTypes.bool,
  href: PropTypes.string
};

export default CallToAction;
